/* eslint-disable */

import React, { Component } from "react";
import PropTypes from "prop-types";
import { FormControl } from "react-bootstrap";
import TimeZoneSelect from "./TimeZoneSelect";
import moment from "moment";
import * as Constants from '../constants';

class CompanySettingsForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    company: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      use_office_hours: this.props.company.use_office_hours || false,
      office_hours: this.props.company.office_hours,
      office_hour_services: this.props.company.office_hour_services,
      time_zone: this.props.company.time_zone,
      errors: {}
    };
  }

  save(e) {
    e.preventDefault();
    if (Object.keys(this.state.errors).length == 0) {
      this.props.handleSubmit(this.state);
    }
  }

  timeOptions() {
    let options = ["AM", "PM"].map(i => {
      return this.hourOptions(i);
    });
    return options;
  }

  hourOptions(ampm) {
    let hours = [
      "12",
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11"
    ];
    let options = hours.map(i => {
      return this.minuteOptions(i, ampm);
    });
    return options;
  }

  minuteOptions(hour, ampm) {
    let minutes = ["00", "15", "30", "45"];
    let options = minutes.map(i => {
      let military_time = moment(`${hour}:${i} ${ampm}`, "hh:mm A").format(
        "HH:mm"
      );
      return (
        <option key={military_time} value={military_time}>
          {hour}:{i} {ampm}
        </option>
      );
    });
    return options;
  }

  handleTimeZoneChange(time_zone) {
    this.setState({ time_zone: time_zone });
  }

  handleChange(e) {
    this.setState({
      use_office_hours: this.refs.use_office_hours.checked,
      office_hour_services: this.getOfficeHourServices(),
      office_hours: this.getOfficeHours()
    });
  }

  getOfficeHourServices() {
    let office_hour_services = [];
    if (this.refs.office_hour_services_email.checked == true) {
      office_hour_services.push("email");
    }
    if (this.refs.office_hour_services_sms.checked == true) {
      office_hour_services.push("sms");
    }
    if (this.refs.office_hour_services_rvm.checked == true) {
      office_hour_services.push("rvm");
    }
    return office_hour_services;
  }

  getOfficeHours() {
    let office_hours = {};
    if (this.refs.use_office_hours.checked === true) {
      for (let i = 0; i <= 6; i++) {
        let refName = i + "_useOfficeHours";
        if (this.refs[refName].checked == true) {
          let start_time = this[`startTime_${i}`].value;
          let end_time = this[`endTime_${i}`].value;
          office_hours[i] = [start_time, end_time];
        }
      }
    }
    return office_hours;
  }

  renderDays() {
    let days = [1, 2, 3, 4, 5, 6, 0].map(i => {
      return this.renderDay(i);
    });
    return days;
  }

  showRVM() {
    return Constants.BETA_SITE_UUIDS.includes(localStorage.getItem('lastSiteUUID'))
  }

  getWeekDay(weekday_num) {
    let weekday = new Array(7);
    weekday[0] = "Sunday";
    weekday[1] = "Monday";
    weekday[2] = "Tuesday";
    weekday[3] = "Wednesday";
    weekday[4] = "Thursday";
    weekday[5] = "Friday";
    weekday[6] = "Saturday";
    return weekday[weekday_num];
  }

  applyRef = (time, index, ref) => {
      this[`${time}_${index}`] = ref;
  };

  renderDay(day_of_week) {
    let start_time = "09:00";
    let end_time = "17:00";
    if (
      this.state.office_hours &&
      Object.keys(this.state.office_hours).length > 0
    ) {
      let hours = this.state.office_hours[day_of_week];
      if (hours) {
        start_time = hours[0];
        end_time = hours[1];
      }
    }
    return (
      <div className="row" key={day_of_week}>
        <div className="col-sm-1" style={{ marginTop: "6px" }}>
          <span>{this.getWeekDay(day_of_week)}</span>
        </div>

        <div className="col-sm-2" style={{ marginTop: "6px" }}>
          <label>Open</label>
          <input
            type="checkbox"
            ref={`${day_of_week}_useOfficeHours`}
            className="m-l-10 m-r-10"
            id="officeHours"
            onChange={this.handleChange.bind(this)}
            disabled={this.state.use_office_hours === false}
            checked={this.state.office_hours[day_of_week]}
          />
        </div>

        <div
          className={`col-sm-3 form-group time-select-group ${
            this.state.errors.office_hours ? "has-error" : ""
          }`}
        >
          <label className="m-r-5">Start</label>
          <FormControl
            componentClass="select"
            type="select"
            className="form-control"
            labelClassName=""
            wrapperClassName=""
            value={start_time}
            disabled={this.state.office_hours[day_of_week] === undefined || this.state.use_office_hours === false}
            key={`startTime_${day_of_week}`}
            inputRef={this.applyRef.bind(this, 'startTime', day_of_week)}
            onChange={this.handleChange.bind(this)}
          >
            {this.timeOptions()}
          </FormControl>
        </div>

        <div
          className={`col-sm-3 form-group time-select-group ${
            this.state.errors.office_hours ? "has-error" : ""
          }`}
        >
          <label className="m-r-5">End</label>
          <FormControl
            componentClass="select"
            type="select"
            className="form-control "
            labelClassName=""
            wrapperClassName=""
            value={end_time}
            key={`endTime_${day_of_week}`}
            disabled={this.state.office_hours[day_of_week] === undefined || this.state.use_office_hours === false}
            inputRef={this.applyRef.bind(this, 'endTime', day_of_week)}
            onChange={this.handleChange.bind(this)}
          >
            {this.timeOptions()}
          </FormControl>
        </div>
        <div className="help-block">{this.state.errors.office_hours}</div>
      </div>
    );
  }

  render() {
    return (
      <form onSubmit={this.save.bind(this)}>
        <div className="row m-t-40">
          <div className="col-sm-2">
            <label>Enable Office Hours:</label>
          </div>
          <div className="col-sm-10">
            <div
              className={`form-group time-select-group ${
                this.state.errors.use_office_hours ? "has-error" : ""
              }`}
            >
              <input
                type="checkbox"
                className="office-hours-checkbox"
                id="use_office_hours"
                name="use_office_hours"
                ref="use_office_hours"
                value={this.state.use_office_hours}
                checked={this.state.use_office_hours}
                onChange={this.handleChange.bind(this)}
              />
              <div className="help-block">
                {this.state.errors.use_office_hours}
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-2">
            <label>Apply Office Hours to:</label>
          </div>
          <div className="col-sm-10">
            <div
              className={`form-group time-select-group ${
                this.state.errors.office_hour_services_email ? "has-error" : ""
              }`}
            >
              SMS
              <input
                type="checkbox"
                className="office-hours-checkbox m-l-10 m-r-10"
                ref="office_hour_services_sms"
                checked={this.state.office_hour_services.includes("sms")}
                onChange={this.handleChange.bind(this)}
              />
              <span className={`${ this.showRVM() ? "" : "hide" }`}>
                Voicemail
                <input
                  type="checkbox"
                  className="office-hours-checkbox m-l-10 m-r-10"
                  ref="office_hour_services_rvm"
                  checked={this.state.office_hour_services.includes("rvm")}
                  onChange={this.handleChange.bind(this)}
                />
              </span>
              Email
              <input
                type="checkbox"
                className="office-hours-checkbox m-l-10 m-r-10"
                ref="office_hour_services_email"
                checked={this.state.office_hour_services.includes("email")}
                onChange={this.handleChange.bind(this)}
              />
              <div className="help-block">
                {this.state.errors.office_hour_services_email}
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-2">
            <label>Time Zone:</label>
          </div>
          <div className="col-sm-10">
            <div
              className={`form-group time-select-group ${
                this.state.errors.timezone ? "has-error" : ""
              }`}
            >
              <TimeZoneSelect
                officeHoursEnabled={this.state.use_office_hours}
                timezone={this.state.time_zone}
                handleChange={this.handleTimeZoneChange.bind(this)}
              />
              <div className="help-block">{this.state.errors.timezone}</div>
            </div>
          </div>
        </div>
        <div className="row m-b-20">
          <div className="col-sm-12">
            <label>Days of Week:</label>
          </div>
        </div>
        {this.renderDays()}
        <button type="submit" className="btn btn-lg btn-primary">
          Save Settings
        </button>
      </form>
    );
  }
}

export default CompanySettingsForm;
